/*@ngInject*/
const emailRecipientsFilter = function () {
    return function (recipients) {
        // This filter will add whitespace between the given email recipients in order to avoid word wrap
        // issues
        return _.join(_.split(recipients, ','), ', ');
    };
};

angular.module('umCore')
    .filter('emailRecipientsFilter', emailRecipientsFilter);
